export class BasicUser {
  id: number;
  userId?: number;
  name?: string;
  fullName?: string;
  firstName: string;
  lastName: string;
  emailAddress?: string;

  constructor (user: any = {}) {
    this.id = user.id || null;
    this.firstName = user.firstName || '';
    this.lastName = user.lastName || '';
    this.emailAddress = user.emailAddress || '';
    if (user.fullName) {
      this.fullName = user.fullName;
    } else if (user.firstName && user.lastName) {
      this.fullName = `${user.firstName} ${user.lastName}`;
    } else {
      this.fullName = '';
    }
  }
}

